import http from '@libs/http';
import {
  Cash,
  EPaymentsResult,
  LastWithdrawalQuery,
  BankAccountsQuery,
  DepositsQuery,
  DepositReceiptAttachmentQuery,
  TurnoverResult,
  TurnoverReportResult,
  CreateTokenRequest,
  CreateTokenResponse,
  CreateBankAccountRequest,
  RegisterReceiptRequest,
  DirectDebitRequest,
  DirectDebitsQuery,
} from '@libs/api-reference';

import { TSE_API } from './endpoints';

type CreateWithdrawData = {
  destinationAccountId: number;
  withdrawalValue: number;
  sourceAccountUsageType: 1 | 2 | 4 | 8 | 16;
  dueDate?: Date;
  requestDepositDate: Date;
  description?: string;
};

export type GetAccountTurnoverParamsType = {
  fromDate: string;
  endDate: string;
  pageNumber?: number;
  pageSize?: number;
  personageId?: number;
};

export type GetAccountTurnoverReportParamsType = {
  type: number;
  fromDate: string;
  endDate: string;
  isDetail?: boolean;
  pageNumber?: number;
  pageSize?: number;
};

export function getCashAsset(bourseCodeId = 534308) {
  return http.get<Cash>(`${TSE_API}/customers/{bourseCodeId}/accountstates`, {
    urlParams: { bourseCodeId },
    schema: Cash,
  });
}

export function createApPaymentToken(data: CreateTokenRequest) {
  return http.post<CreateTokenResponse>(`${TSE_API}/asanpardakht/token`, data, {
    schema: CreateTokenResponse,
  });
}

export function createSamanPaymentToken(data: CreateTokenRequest) {
  return http.post<CreateTokenResponse>(`${TSE_API}/saman/token`, data, {
    schema: CreateTokenResponse,
  });
}

export function createBehPardakhtPaymentToken(data: CreateTokenRequest) {
  return http.post<CreateTokenResponse>(`${TSE_API}/behpardakht/token`, data, {
    schema: CreateTokenResponse,
  });
}

export function createJibimoPaymentToken(data: CreateTokenRequest) {
  return http.post<CreateTokenResponse>(`${TSE_API}/jibimo/token`, data, {
    schema: CreateTokenResponse,
  });
}

export function createWithdrawal(data: CreateWithdrawData) {
  return http.post(`${TSE_API}/withdraws`, data);
}

export function getPayableAmounts() {
  return http.get(`${TSE_API}/epayments/payableamountstates`);
}

export function getEPayments(params: Record<string, any>) {
  return http.get<EPaymentsResult>(`${TSE_API}/epayments`, {
    params,
    schema: EPaymentsResult,
  });
}

export function getLastWithdrawals(params: Record<string, any>) {
  return http.get<LastWithdrawalQuery>(`${TSE_API}/withdraws`, {
    params,
    schema: LastWithdrawalQuery,
  });
}

export function deleteWithdrawal(data: number) {
  return http.delete(`${TSE_API}/withdraws/{requestId}`, {
    urlParams: { requestId: data },
  });
}
export function getBrokerBankAccounts() {
  return http.get<BankAccountsQuery>(`${TSE_API}/bankaccounts`, {
    schema: BankAccountsQuery,
  });
}

export function getLastDepositReceipts(params) {
  return http.get<DepositsQuery>(`${TSE_API}/deposits`, {
    params,
    schema: DepositsQuery,
  });
}
export function registerDepositReceipt(data: RegisterReceiptRequest) {
  return http.post(`${TSE_API}/deposits`, data);
}

export function deleteDepositReceipt(requestId: string) {
  return http.delete(`${TSE_API}/deposits/{requestId}`, {
    urlParams: { requestId },
  });
}

export function getDepositReceiptAttachment(id: number | null) {
  return http.get<DepositReceiptAttachmentQuery>(
    `${TSE_API}/deposits/{id}/attachment`,
    {
      urlParams: { id },
      schema: DepositReceiptAttachmentQuery,
    }
  );
}

export function getAccountTurnover(params: GetAccountTurnoverParamsType) {
  return http.get<TurnoverResult>(`${TSE_API}/balancesheets`, {
    params,
    schema: TurnoverResult,
  });
}

export function getAccountTurnoverReport(
  params: GetAccountTurnoverReportParamsType
) {
  return http.get<TurnoverReportResult>(`${TSE_API}/balancesheets/file`, {
    params,
    schema: TurnoverReportResult,
  });
}

export function getDirectDebits() {
  return http.get<DirectDebitsQuery>(`${TSE_API}/directdebits/contracts`, {
    schema: DirectDebitsQuery,
  });
}

export function directDebit(data: DirectDebitRequest) {
  return http.post(`${TSE_API}/directdebits`, data);
}

export function createBankAccount(data: CreateBankAccountRequest) {
  return http.post(`${TSE_API}/personage/bankaccounts`, data);
}
